{
  "exclusiveOverviewPage.title": "专属访问",
  "exclusiveOverviewPage.notification.permanent.learnMoreLinkText": "了解更多",
  "exclusiveOverviewPage.notification.permanent": "永久专属访问是指您网站上的某个 URL 被永久冻结，仅供特定会员访问。您可以同时提供和管理多种专属访问类型。{learnMoreLink}。",
  "exclusiveOverviewPage.notification.limited.learnMoreLinkText": "了解更多",
  "exclusiveOverviewPage.notification.limited": "受限专属访问是指您网站上的某个 URL 被暂时冻结，仅供特定会员访问。访问有效期与排他性期间相同。排他性期间过期后，将无法再次访问排他性。{learnMoreLink}。",
  "exclusiveOverviewPage.card.activeAndConnectedTooltip": "排他性处于活动状态且访问连接到：{text}",
  "exclusiveOverviewPage.card.activeReadyToConnectTooltip": "冻结处于活动状态且访问已做好连接准备。",
  "exclusiveOverviewPage.card.deactivatedTooltip": "您已取消激活排他性，现在可以编辑并重新激活它。",
  "exclusiveOverviewPage.card.inactiveTooltip": "设置尚未完成。",
  "exclusiveOverviewPage.card.expiredTooltip": "此排他性已过期。您可以复制并编辑此排他性。",
  "exclusiveOverviewPage.card.scheduledTooltip": "已针对 {text} 计划此排他性",
  "exclusiveOverviewPage.card.info.offersAndValidity": "优惠和有效期",
  "exclusiveOverviewPage.card.info.accessAsFixedBenefit": "访问作为固定福利",
  "exclusiveOverviewPage.card.info.accessAsAdditionalBenefits": "访问作为附加福利",
  "exclusiveOverviewPage.card.info.accessAsReward": "访问作为操作奖励",
  "exclusiveOverviewPage.card.info.accessForPoints": "积分访问",
  "exclusiveOverviewPage.card.info.accessForFree": "免费访问",
  "exclusiveOverviewPage.card.connectedTo": "连接至",
  "exclusiveOverviewPage.card.walletInTooltip": "Loyalty Wallet/API",
  "exclusiveOverviewPage.card.deleteDialog.headline": "是否确定要删除此访问？",
  "exclusiveOverviewPage.card.deleteDialog.content": "删除访问权限后，访问不再是独占的，所有 URL 块都将被移除。",
  "exclusiveOverviewPage.card.newCardText": "创建 {value}",
  "exclusiveOverviewPage.filters.search.label": "搜索",
  "exclusiveOverviewPage.filters.status.label": "状态",
  "exclusiveSetupPage.confirmMultilang.headline": "是否确定已完成排他性设置？",
  "exclusiveSetupPage.confirmMultilang.content": "您尚未为所有现有语言定义 URL。独占访问权限不适用于未定义 URL 的语言。",
  "exclusiveSetupPage.errors.editorStep": "输入所有四个冻结版本。",
  "exclusiveSetupPage.exclusiveAccessAndOffer.notification": "设置积分值不是必需的，但您可以使用它为会员提供此积分访问权限。",
  "exclusiveSetupPage.multiLangPopupTitle": "基于语言的 URL",
  "exclusiveSetupPage.activeEditAlert": "您正在编辑处于活动状态的排他性。您的更改将立即影响会员。",
  "exclusiveAccessCustomHtmlEditor.editorSide.emptyContentPlaceholder.heading": "在此粘贴或输入您的 HTML 代码。",
  "exclusiveAccessCustomHtmlEditor.editorSide.emptyContentPlaceholder.content": "您可以将源文件拖放到此处。",
  "exclusiveAccessCustomHtmlEditor.previewSide.emptyContentPlaceholder.heading": "在此粘贴或输入您的 HTML 代码。",
  "exclusiveAccessCustomHtmlEditor.previewSide.emptyContentPlaceholder.content": "此处显示您的冻结页面的预览。",
  "stylePicker.overlayColor.label": "叠加颜色",
  "stylePicker.overlayOpacity.label": "叠加透明度",
  "stylePicker.contentBackgroundColor.label": "内容背景颜色",
  "stylePicker.tagColor.label": "标签颜色",
  "stylePicker.tagRadius.label": "标签半径",
  "stylePicker.leftButtonBackgroundColor.label": "按钮 1 背景颜色",
  "stylePicker.rightButtonBackgroundColor.label": "按钮 2 背景颜色",
  "stylePicker.buttonRadius.label": "按钮半径",
  "linkPickers.leftButtonLink.label": "按钮 1 链接",
  "linkPickers.rightButtonLink.label": "按钮 2 链接",
  "exclusiveAccessCustomTemplateEditor.styleEditorSidebar.sidebarBody.title": "冻结页面编辑器",
  "exclusiveAccessCustomTemplateEditor.highlightEditable.switch.label": "突出显示可编辑内容",
  "linkDialog.linkDialogPopup.title": "链接编辑器",
  "linkDialog.lsOpenWalletCb.label": "会员单击按钮后显示钱包。",
  "linkButtonOptions.return.name": "返回上一页",
  "linkButtonOptions.redirect.name": "添加重定向 URL",
  "stylePickerBar.closeButtonPoitionOptions.topRight": "右上",
  "stylePickerBar.closeButtonPoitionOptions.topLeft": "左上",
  "memberModTabs.member.value": "会员",
  "memberModTabs.nonMember.value": "非会员",
  "exclusiveAccessSetupSettings.accessName.label": "访问名称",
  "validityPeriodSetup.accessValidityType.placeholder": "选择访问有效期选项",
  "validityPeriodSetup.accessValidity.duration.label": "选择有效期",
  "exclusiveAccessAndOffer.redemptionMessageTooltip.free": "输入此访问的优惠消息以显示在 Loyalty Wallet 中。这允许会员获得优惠。",
  "exclusiveAccessAndOffer.redemptionMessageTooltip.points": "输入此访问的优惠消息以显示在 Loyalty Wallet 中。文本字段包含为每个层级定义的积分令牌中的值。",
  "exclusiveAccessAndOffer.offerMessage.header": "优惠消息",
  "exclusiveAccessAndOffer.offerMessage.title.label": "头衔",
  "exclusiveAccessAndOffer.offerMessage.text.label": "文本",
  "exclusiveAccessAndOffer.offerRestriction.title": "优惠限制",
  "exclusiveAccessAndOffer.offerRestriction.tooltip": "输入会员在活动时间期间内可以获得此访问权限的次数。激活新优惠后，此限制将被重置。",
  "exclusiveAccessAndOffer.offerRestriction.limitValue.label": "优惠数量",
  "exclusiveAccessAndOffer.offerStatusAnbValidity.isNewOfferRb.label": "优惠状态和有效期",
  "exclusiveAccessAndOffer.offerStatusAnbValidity.isNewOfferRb.tooltip": "选择优惠状态以及优惠在 Loyalty Wallet 中可供会员使用的时间期间。",
  "exclusiveAccessAndOffer.offerTiersAndValue.points.label": "层级和值",
  "exclusiveAccessAndOffer.offerTiersAndValue.points.tooltip": "选择您想要授予访问权限的层级以及获得此访问权限的每个层级所需的积分。选择此层级并激活此优惠后，优惠将显示给 Loyalty Wallet 中的会员。",
  "exclusiveAccessAndOffer.offerTiersAndValue.other.label": "激活您想要提供免费访问权限的层级。",
  "exclusiveAccessAndOffer.accessValidity.mainLabel": "访问有效期",
  "exclusiveAccessAndOffer.accessValidity.validityDurationTooltip": "选择此专属访问的有效期，从会员获得访问权限时计算。",
  "exclusiveAccessAndOffer.accessValidity.action.showOnActionCb.label": "启用访问可用性作为操作奖励。",
  "exclusiveAccessAndOffer.accessValidity.action.showOnActionCb.tooltip": "要禁用此选项，请断开专属访问奖励与操作的连接：{names}",
  "exclusiveAccessAndOffer.accessValidity.tooltip.connected": "选择此访问的有效期类型。过期的访问权限将自动从 Loyalty Wallet 中移除。要禁用操作的访问可用性，请断开专属访问与操作的连接。",
  "exclusiveAccessAndOffer.accessValidity.tooltip": "选择此访问的有效期类型。过期的访问权限将自动从 Loyalty Wallet 中移除。",
  "exclusiveAccessAndOffer.title": "访问和优惠",
  "exclusiveAccessAndOffer.alert": "排他性和访问权限在以下范围有效",
  "exclusiveAccessAndOffer.desctiption.limited": "您可以提供对专属 URL 的访问权限，作为对操作、积分或免费的奖励。定义并激活所需访问权限和优惠。",
  "exclusiveAccessAndOffer.desctiption.permanent": "定义并激活专属 URL 所需访问权限和优惠。您可以同时拥有多种访问权限类型。",
  "excluxiveAccessSetupSettings.notice.multimarket": "为此排他性输入特定市场和 URL。确保为所选市场定义所有相关语言。",
  "excluxiveAccessSetupSettings.generalSettings.title": "常规设置",
  "excluxiveAccessSetupSettings.pageSettings.title": "页面设置",
  "excluxiveAccessSetupSettings.pageSettings.tooltip": "排他性处于活动状态后，指定的 URL 上会向无访问权限的会员显示冻结叠加。",
  "excluxiveAccessSetupSettings.market.label": "选择市场",
  "excluxiveAccessSetupSettings.market.tooltip": "选择此专属页面的目标市场。",
  "excluxiveAccessSetupSettings.blocking.isStartsWith.label": "专属页面 URL",
  "excluxiveAccessSetupSettings.blocking.landingPageUrl.label": "登录页面 URL",
  "excluxiveAccessSetupSettings.blocking.landingPageUrl.tooltip": "当会员有访问权限时，会显示此页面。",
  "excluxiveAccessSetupSettings.blocking.startsWithAccessUrl.label": "冻结访问并提供对以此 URL 开头的所有页面的专属访问权限：",
  "excluxiveAccessSetupSettings.blockingValidity.title": "排他性有效期",
  "excluxiveAccessSetupSettings.blockingValidity.tooltip": "定义排他性处于活动状态的时间期间。排他性有效期和访问权限对所有会员都相同。过期后，您无法再次使用此排他性访问权限。",
  "excluxiveAccessSetupSettings.exclusiveAccess.name.label": "专属名称",
  "excluxiveAccessSetupSettings.exclusiveAccess.name.tooltip": "此访问权限的内部名称，用于将专属访问权限与福利、操作和优惠联系起来。",
  "exclusiveAccessSetupSettings.accessName.tooltip": "输入向会员显示的此访问权限的名称。",
  "exclusiveAccessSetupSettings.accessIcon.label": "访问图标",
  "exclusiveAccessSetupSettings.accessIcon.selectIconText": "添加到访问",
  "exclusiveAccessSetupSettings.validity.blockingValidity.end.label": "排他性有效期",
  "exclusiveAccessSetupSettings.validity.blockingValidity.end.tooltip": "定义排他性处于活动状态的时间期间。过期后，每个人都有访问权限，并且您不能再次使用此排他性访问权限。",
  "exclusiveAccessValidity.title": "激活",
  "exclusiveAccessValidity.notice": "激活此专属页面后，它将被冻结，并且根据您的设置限制访问。\n取消激活此专属页面后，冻结将被移除，并且该页面可供所有成员使用。",
  "exclusiveAccessValidity.deactivateDialog.headline": "是否确定要取消激活此排他性？",
  "exclusiveAccessValidity.deactivateDialog.content": "取消激活此专属页面后，冻结将被移除，并且该页面可供所有成员使用。",
  "exclusiveAccessValidity.deactivateDialog.confirmLabel": "取消激活",
  "exclusiveAccessPopupValidator.redirectUrl.presence": "输入重定向 URL。",
  "exclusiveAccessPopupValidator.redirectUrl.preurlsence": "输入有效的重定向 URL。",
  "externalEventsValidator.name.presence": "输入外部事件名称。",
  "excluseiveAccesssValidator.accessValidity.presence": "输入访问有效期。",
  "excluseiveAccesssValidator.accessValidity.numericality.notInteger": "输入大于零的访问有效期。",
  "excluseiveAccesssValidator.accessValidity.numericality.notGreaterThan": "输入大于零的访问有效期。",
  "excluseiveAccesssValidator.exclusiveOfferMaxDate": "输入早于专属访问过期日期的优惠结束日期。",
  "excluseiveAccesssValidator.redemptionConstriants.message.title": "输入标题",
  "excluseiveAccesssValidator.redemptionConstriants.message.text": "输入消息文本。",
  "excluseiveAccesssValidator.redemptionConstriants.message.accessValidityType": "输入有效期类型。",
  "excluseiveAccesssValidator.redemptionConstriants.limitValue.presence": "输入大于零的显示数量。",
  "excluseiveAccesssValidator.redemptionConstriants.limitValue.numericality.notInteger": "输入大于零的显示数量。",
  "excluseiveAccesssValidator.redemptionConstriants.limitValue.numericality.notGreaterThan": "输入大于零的显示数量。",
  "excluseiveAccesssValidator.redemptionConstriants.offerValidity.dateRange.messageEmpty": "输入优惠有效期。",
  "excluseiveAccesssValidator.redemptionConstriants.offerValidity.dateRange.messageRangeNotValid": "专属访问的有效期至少为一小时。",
  "excluseiveAccesssValidator.redemptionConstriants.exclusiveOfferMaxDate": "输入有效优惠结束日期。",
  "excluseiveAccesssValidator.redemptionConstriants.value.points.notInteger": "输入大于零的积分数量。",
  "excluseiveAccesssValidator.redemptionConstriants.value.points.notGreaterThan": "输入大于零的积分数量。",
  "excluseiveAccesssValidator.poolSettingsConstriants.name.presence": "输入池名称。",
  "excluseiveAccesssValidator.poolSettingsConstriants.name.exclusionIgnoreCase": "此名称已存在。输入唯一名称。",
  "excluseiveAccesssValidator.poolSettingsConstriants.accessName.presence": "输入访问名称。",
  "excluseiveAccesssValidator.poolSettingsConstriants.blocking.landingPageUrl.presence": "输入登录页面 URL。",
  "excluseiveAccesssValidator.poolSettingsConstriants.blocking.landingPageUrl.url": "输入有效的登录页面 URL。",
  "excluseiveAccesssValidator.poolSettingsConstriants.blocking.startsWithAccessUrl.presence": "输入登录页面 URL。",
  "excluseiveAccesssValidator.poolSettingsConstriants.blocking.startsWithAccessUrl.url": "输入有效的登录页面 URL。",
  "excluseiveAccesssValidator.poolSettingsConstriants.blocking.startsWithAccessUrl.exclusionOrStartWithIgnoreCase": "此页面 URL 已在另一个排他性中定义。输入唯一页面 URL。",
  "excluseiveAccesssValidator.poolSettingsConstriants.market.presence": "输入市场。",
  "excluseiveAccesssValidator.poolSettingsConstriants.validity.blockingValidity.dateRange.messageEmpty": "输入排他性有效期。",
  "excluseiveAccesssValidator.poolSettingsConstriants.validity.blockingValidity.dateRange.messageRangeNotValid": "输入至少 12 小时的排他性有效期。",
  "excluseiveAccesssValidator.accessValidityConstriants.duration.accessValidity.messageRequired": "输入大于零的访问有效期。",
  "excluseiveAccesssValidator.accessValidityConstriants.duration.accessValidity.messageHigherThanZero": "输入大于零的访问有效期。",
  "excluseiveAccesssValidator.accessValidityConstriants.accessDateRange.messageEmpty": "输入冻结有效期。",
  "excluseiveAccesssValidator.accessValidityConstriants.accessDateRange.messageRangeNotValid": "输入至少 12 小时的冻结时间。",
  "singelRedemtionValue.presence": "输入数字或禁用此层级的优惠。",
  "exclusiveSetupPage.title.new": "新 {value} 访问",
  "stylePickerBar.notificationContent.Member": "覆盖不具有独占访问的忠诚度会员的按钮文本和 URL。",
  "stylePickerBar.notificationContent.nonMember": "覆盖不具有独占访问的非会员的按钮文本和 URL。",
  "memberModTabs.template.value": "常规：设计和文本影响所有屏幕。"
}
